






















import { defineComponent, type PropType } from "vue-demi";
import {
  type CombinePrice,
  PriceType,
  type Price,
} from "@constructor/shared-entity/type";
import { formatPrice } from "@artmizu/utils";

export default defineComponent({
  name: "GGPrice",
  props: {
    price: {
      type: Object as PropType<CombinePrice>,
      required: true,
    },
    size: {
      type: String as PropType<"small" | "regular" | "big">,
      default: "regular",
    },
    color: {
      type: String as PropType<"grey" | "yellow">,
      default: "grey",
    },
  },
  computed: {
    beautifyPriceCommon() {
      return this.price.common.value
        ? formatPrice(this.price.common.value)
        : null;
    },
    beautifyPriceDiscount() {
      return this.price.discount?.value
        ? formatPrice(this.price.discount.value)
        : null;
    },
  },
  methods: {
    getCodeStyle(priceCode: PriceType) {
      if (priceCode === PriceType.Promo || priceCode === PriceType.Rrc) {
        return "crossed-style price__crossed";
      }
    },
    getCodeStyleCommon(price: Price) {
      if (
        (price.value > 0 && price.type === PriceType.Promo) ||
        price.type === PriceType.Rrc
      ) {
        return "red-text";
      }
    },
  },
});
